import { useNavigate } from 'react-router-dom';
import DashboardLayout from '@/pages/dashboard/components/DashboardLayout';
import GigForm from '@/pages/dashboard/gigs/components/GigForm';
import { useAuth } from '@/context/AuthContext';

function GigNew() {
  const { user } = useAuth();
  const navigate = useNavigate();

  if (!user) return null;

  return (
    <DashboardLayout>
      <div className="mb-8">
        <h1 className="font-heading font-bold text-2xl md:text-3xl text-foreground-50">Nouveau service</h1>
        <p className="text-sm text-foreground-400 mt-1">
          Proposez un service et recevez des commandes directement sur la plateforme.
        </p>
      </div>

      <div className="max-w-3xl">
        <GigForm ownerId={user.id} onSaved={() => navigate('/dashboard/gigs')} />
      </div>
    </DashboardLayout>
  );
}

export default GigNew;